import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import apiClient from "../../api/ApiClients";
import CustomAlertDialog from "../../components/alerts/CustomAlertDialog";
import Sidebar from "../../components/layout/Sidebar";
import BlogCategoryDialog from "./components/BlogCategoryDialog";

const BlogCategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  const fetchCategories = async () => {
    try {
      const res = await apiClient.request("blog-category", "GET");
      setCategories(res.blogCategories || []);
    } catch (e) {
      toast.error("Failed to fetch categories");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleAddCategory = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      if (data.image) formData.append("image", data.image);
      const res = await apiClient.request(
        "blog-category",
        "POST",
        formData,
        true
      );
      if (res) {
        toast.success("Category added");
        setShowDialog(false);
        fetchCategories();
      }
    } catch (e) {
      toast.error("Failed to add category");
    }
  };

  const handleUpdateCategory = async (id, data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      if (data.image) formData.append("image", data.image);
      if (data.oldImage) formData.append("oldImage", data.oldImage);
      const res = await apiClient.request(
        `blog-category/${id}`,
        "PUT",
        formData,
        true
      );
      if (res) {
        toast.success("Category updated");
        setShowDialog(false);
        fetchCategories();
      }
    } catch (e) {
      toast.error("Failed to update category");
    }
  };

  const handleDeleteCategory = async () => {
    try {
      await apiClient.request(`blog-category/${categoryToDelete}`, "DELETE");
      toast.success("Category deleted");
      setShowAlert(false);
      fetchCategories();
    } catch (e) {
      toast.error("Failed to delete category");
    }
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper" style={{ padding: "0px" }}>
        <div className="customHeader">
          <div className="headerContent">
            <h2>Blog Categories</h2>
            <Button
              onClick={() => {
                setSelectedCategory(null);
                setShowDialog(true);
              }}
            >
              Add New
            </Button>
            <BlogCategoryDialog
              show={showDialog}
              handleClose={() => setShowDialog(false)}
              onCancel={() => setShowDialog(false)}
              onSubmit={
                selectedCategory ? handleUpdateCategory : handleAddCategory
              }
              selectedCategory={selectedCategory}
            />
          </div>
          <hr />
        </div>
        <div className="px-4">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((cat) => (
                  <tr key={cat._id}>
                    <td>{cat.name}</td>
                    <td>
                      {cat.image && (
                        <img
                          src={cat.image}
                          alt="Category"
                          style={{ maxWidth: 80, maxHeight: 80 }}
                        />
                      )}
                    </td>
                    <td>
                      <Button
                        variant="outline-dark"
                        onClick={() => {
                          setSelectedCategory(cat);
                          setShowDialog(true);
                        }}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        variant="outline-danger"
                        onClick={() => {
                          setCategoryToDelete(cat._id);
                          setShowAlert(true);
                        }}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <CustomAlertDialog
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            title="Delete"
            subtitle="Are you sure you want to delete this category?"
            buttonText="Delete"
            onCancel={() => setShowAlert(false)}
            onClick={handleDeleteCategory}
            isDanger
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default BlogCategoryPage;
